import React from "react";
import ReactDOM from "react-dom/client";
import "@/utils/lazy79";  // LOT 79 · avant App : tout écran chargé à la demande apporte aussi les styles des autres pages
import "@/index.css";
import "@/styles/couleurs-roles.css";
import "@/styles/couleurs-palette.css";
import "@/styles/lot6-onglets.css";
import "@/styles/lot7-mobile.css";
import "@/utils/appelsUniques";
import "@/utils/typo-fr";
import { installerChiffresInsecables } from "@/utils/chiffresInsecables";
import App from "@/App";
import { installChunkedUploads } from "@/utils/chunkedUploads";
import { installerTelechargements } from "@/utils/telechargements";
installerChiffresInsecables();
installChunkedUploads();
installerTelechargements();
import { installerCache360 } from "@/lib/cache360";
installerCache360();  // LOT 79 · vitesse : pages gardées en mémoire, appels en double fusionnés, modules préchargés
import "@/styles/mobile-app.css";
import "@/styles/da-adn.css";
import "@/styles/da-passe3.css";
import "@/components/da/kit.css";
import "@/styles/da-happn.css";
import "@/styles/finance-happn.css";
import "@/styles/app-happn.css";
import "@/styles/mobile-rails.css";
import "@/styles/kit-360.css";
import "@/styles/charte-ux.css";
import "@/styles/mobile-fixes.css";
import "@/styles/overflow-fixes.css";
import "@/styles/mobile-happn.css";
import "@/styles/ig-kit.css";
import "@/components/ig/ico-rond.css";
import "@/styles/mobile-socle.css";
import "@/styles/lot9-finitions.css";
import "@/styles/lot11-finitions.css";
import "@/styles/lot34.css";
import "@/styles/lot44.css";
import "@/styles/lot45.css";
import "@/styles/lot53.css";
import "@/styles/socle-applique.css";
import "@/styles/widgets64.css";
import "@/styles/lot67.css";
import "@/styles/lot74-checkup.css";
import "@/styles/credits-bouton.css";
import "@/styles/lot75.css";
import { demarrerContrasteAuto } from "@/utils/contrasteAuto";
import { installerGardeCompte } from "@/utils/gardeCompte";
installerGardeCompte();
import { garderSeparateurs } from "@/utils/separateurs";
garderSeparateurs();
import { installerImagesSures } from "@/utils/imagesSures";
import '@/styles/nuit78.css';  // LOT 78 · palette nuit unique, en dernier
import '@/styles/nuit79.css';  // LOT 79 · mode nuit propre : jetons + 6 règles, en dernier
import '@/styles/lot80.css';  // LOT 80 · cartes espacées et en-têtes alignés, jour comme nuit
import '@/styles/vitesse79.css';
installerImagesSures();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// LOT 33 · www.360-resto.com → 360-resto.com (la 301 côté hébergeur reste à poser)
if (window.location.hostname.startsWith('www.')) window.location.replace(window.location.href.replace('://www.', '://'));
// LOT 33 · service worker « réseau d'abord » pour index.html (skipWaiting + clients.claim) ; les anciens caches sont vidés à l'activation
if ('serviceWorker' in navigator) { window.addEventListener('load', () => { navigator.serviceWorker.register('/sw.js?v=79').then((r) => r.update().catch(() => {})).catch(() => {}); }); }
// Erreurs JavaScript silencieuses → POST /api/logs/front
const logFront = (message, pile) => { try { fetch(`${process.env.REACT_APP_BACKEND_URL}/api/logs/front`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ message: String(message).slice(0, 500), page: window.location.pathname, pile: String(pile || '').slice(0, 1500) }), keepalive: true }); } catch { /* rien */ } };
window.addEventListener('error', (e) => logFront(e.message, e.error?.stack));
window.addEventListener('unhandledrejection', (e) => { if (!e.reason?.isAxiosError) logFront(e.reason?.message || e.reason, e.reason?.stack); });
demarrerContrasteAuto();
